import {
  SET_MANUFACTURERS_DROPDOWN,
  SET_LOADING_MF_OPTIONS,
  SET_SUBMIT_LOADING,
  SET_PRODUCT_NAME,
  SET_SELECTED_MF,
  SET_STATUS
} from './constants';

export function setManufacturersOptions(options) {
  return {
    type: SET_MANUFACTURERS_DROPDOWN,
    options
  };
}

export function setSubmitLoading(submitLoading) {
  return {
    type: SET_SUBMIT_LOADING,
    submitLoading
  };
}

export function setManufacturersDropdownLoading(optionsLoading) {
  return {
    type: SET_LOADING_MF_OPTIONS,
    optionsLoading
  };
}

export function setProductName(productName) {
  return {
    type: SET_PRODUCT_NAME,
    productName
  };
}

export function setSelectedMF(mfId) {
  return {
    type: SET_SELECTED_MF,
    mfId
  };
}

export function setProductStatus(status) {
  return {
    type: SET_STATUS,
    status
  };
}



// WEBPACK FOOTER //
// ./src/Modules/CreateNewProduct/actions.js